import React from 'react';
import { usePermissions } from '../hooks/usePermissions';
import WorkerAssignment from './WorkerAssignment';

const AssignmentsPage: React.FC = () => {
  const { canView } = usePermissions();

  if (!canView('assignments')) {
    return null;
  }

  return (
    <WorkerAssignment />
  );
};

export default AssignmentsPage; 